import React from 'react';

export const TableHeader = ({ UImobile }) => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th width="165px" className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Дата</span>
        </th>
        <th
            width="120px"
            style={{ textAlign: 'center' }}
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Причина списания</span>
        </th>
        <th width="330px" className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Филиал</span>
        </th>
        <th width="auto" className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Примечание</span>
        </th>
        <th
            width="165px"
            style={{ textAlign: 'center' }}
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Сумма</span>
        </th>
        <th
            width="180px"
            style={{ textAlign: 'right' }}
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}>
            <span>Действия</span>
        </th>
    </tr>
    </thead>
);